define.alias("shared/utils/formatters/ig-post-from-dynamo", "calendar/utils/formatters/ig-post-from-dynamo");